/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * AgreementsApi - axios parameter creator
 * @export
 */
export const AgreementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerCreate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a paginated list of agreements based on search parameters. Only returns agreements that the user has permission to view.
         * @param {string} serviceId
         * @param {AgreementTypeEnum} [agreementType]
         * @param {string} [beneficiaryTitleId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindAll: (serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('agreementControllerFindAll', 'serviceId', serviceId);
            const localVarPath = `/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (agreementType !== undefined) {
                localVarQueryParameter['agreementType'] = agreementType;
            }
            if (beneficiaryTitleId !== undefined) {
                localVarQueryParameter['beneficiaryTitleId'] = beneficiaryTitleId;
            }
            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('agreementControllerFindOne', 'id', id);
            const localVarPath = `/agreement/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOneDownload: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('agreementControllerFindOneDownload', 'id', id);
            const localVarPath = `/agreement/{id}/download`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerRemove: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/agreement/{id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerUpdate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/agreement/{id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AgreementsApi - functional programming interface
 * @export
 */
export const AgreementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AgreementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerCreate(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerCreate(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieves a paginated list of agreements based on search parameters. Only returns agreements that the user has permission to view.
         * @param {string} serviceId
         * @param {AgreementTypeEnum} [agreementType]
         * @param {string} [beneficiaryTitleId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOneDownload(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerFindOneDownload(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerRemove(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerRemove(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerUpdate(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.agreementControllerUpdate(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AgreementsApi - factory interface
 * @export
 */
export const AgreementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AgreementsApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerCreate(options) {
            return localVarFp
                .agreementControllerCreate(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a paginated list of agreements based on search parameters. Only returns agreements that the user has permission to view.
         * @param {string} serviceId
         * @param {AgreementTypeEnum} [agreementType]
         * @param {string} [beneficiaryTitleId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options) {
            return localVarFp
                .agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOne(id, options) {
            return localVarFp
                .agreementControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerFindOneDownload(id, options) {
            return localVarFp
                .agreementControllerFindOneDownload(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerRemove(options) {
            return localVarFp
                .agreementControllerRemove(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerUpdate(options) {
            return localVarFp
                .agreementControllerUpdate(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AgreementsApi - object-oriented interface
 * @export
 * @class AgreementsApi
 * @extends {BaseAPI}
 */
export class AgreementsApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerCreate(options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerCreate(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a paginated list of agreements based on search parameters. Only returns agreements that the user has permission to view.
     * @param {string} serviceId
     * @param {AgreementTypeEnum} [agreementType]
     * @param {string} [beneficiaryTitleId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerFindAll(serviceId, agreementType, beneficiaryTitleId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerFindOne(id, options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerFindOneDownload(id, options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerFindOneDownload(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerRemove(options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerRemove(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    agreementControllerUpdate(options) {
        return AgreementsApiFp(this.configuration)
            .agreementControllerUpdate(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
